import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { HttpService } from '../../data-access/http/http.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private currentLanguageSubject = new BehaviorSubject<string>('ar');
  public currentLanguage$ = this.currentLanguageSubject.asObservable();

  constructor(
    private translateService: TranslateService,
    private cookieService: CookieService,
    private httpService: HttpService
  ) {
    // Initialize with stored language
    const storedLang = localStorage.getItem('language') || 'ar';
    this.currentLanguageSubject.next(storedLang);
  }

  changeLanguage(lang: string): void {
    // Update language in all necessary places
    localStorage.setItem('language', lang);
    this.cookieService.set('language', lang, { path: '/', sameSite: 'Lax' });
    this.translateService.use(lang);

    // Update the observable
    this.currentLanguageSubject.next(lang);
    window.location.reload();
    // Clear HTTP cache to force reload of APIs
    this.httpService.clearCache();
  }

  getCurrentLanguage(): string {
    return this.currentLanguageSubject.value;
  }
}
